import { useEffect, useRef } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class VisitorTracker {
  constructor() {
    this.sessionId = this.getOrCreateSessionId();
    this.baseUrl = API;
  }

  getOrCreateSessionId() {
    let sessionId = sessionStorage.getItem('visitor_session_id');
    if (!sessionId) {
      sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('visitor_session_id', sessionId);
    }
    return sessionId;
  }

  async track(action, data = {}) {
    try {
      const trackingData = {
        session_id: this.sessionId,
        action: action,
        page_url: window.location.href,
        ...data
      };

      await axios.post(`${this.baseUrl}/track/visit`, trackingData, {
        timeout: 5000 // Don't wait too long for tracking
      });
    } catch (error) {
      // Silently fail tracking - don't disrupt user experience
      console.debug('Tracking failed:', error.message);
    }
  }

  trackPageVisit() {
    this.track('visit');
  }

  trackVideoView(videoId) {
    this.track('view', { video_id: videoId });
  }

  trackClick(element, data = {}) {
    this.track('click', data);
  }
}

// Create singleton tracker
const tracker = new VisitorTracker();

export const useTracking = () => {
  const trackedRef = useRef(false);

  useEffect(() => {
    // Track page visit only once per component mount
    if (!trackedRef.current) {
      tracker.trackPageVisit();
      trackedRef.current = true;
    }
  }, []);

  return {
    trackVideoView: (videoId) => tracker.trackVideoView(videoId),
    trackClick: (element, data) => tracker.trackClick(element, data),
    trackPageVisit: () => tracker.trackPageVisit()
  };
};

export default tracker;